import { render } from "./MADoughnutChart.vue?vue&type=template&id=6324c66b&scoped=true"
import script from "./MADoughnutChart.vue?vue&type=script&lang=ts"
export * from "./MADoughnutChart.vue?vue&type=script&lang=ts"

import "./MADoughnutChart.vue?vue&type=style&index=0&id=6324c66b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6324c66b"

export default script